import styled from 'styled-components';

export const ModalOverlay = styled.div``;

export const InstabilityContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & span {
    display: block;
  }
`;
